//Middleware general para hacer llamadas a la API,
export const createMiddlewareAction = ({
  successType,
  failureType,
  method, // metodo, GET, POST, PUT, DELETE
  endpoint, // ruta de la api
  body, // JSON con los datos a enviar
  params, // parametros, como por ejemplo :id, estos son los que van seguido de la ruta
}) => {
  return {
    type: [successType, failureType],
    payload: {
      request: {
        method,
        url: endpoint,
        data: body,
        params,
      },
      options: {
        onSuccess({ ___, dispatch, response }) {
          //si todo va bien se devuelve success y los datos si los tiene que devolver
          return dispatch({
            type: successType,
            payload: response.data,
          })
        },
        onError({ ___, dispatch, error }) {
          return dispatch({
            // la api devulve un error,
            type: failureType,
            payload:
              error.response.status + ' ' + error.response.data ||
              error.response ||
              error.response.data.errors,
          })
        },
        returnRejectedPromiseOnError: true,
      },
    },
  }
}
